import axios from 'axios';

export const cosmos = axios.create({
  baseURL: 'https://cosmos.bluesoft.com.br/api',
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
    'X-Cosmos-Token': process.env.REACT_APP_COSMOS_KEY
  }
});